import { render, staticRenderFns } from "./customer-detail-info.vue?vue&type=template&id=2802b186&scoped=true"
import script from "./customer-detail-info.vue?vue&type=script&lang=ts"
export * from "./customer-detail-info.vue?vue&type=script&lang=ts"
import style0 from "./customer-detail-info.vue?vue&type=style&index=0&id=2802b186&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2802b186",
  null
  
)

export default component.exports